

<template>
  <div class="modal__overlay">
    <div class="modal" @click.stop>
      <button class="modal__close" @click="$emit('closeModal')">&times;</button>
      <ConsultationForm
        :title="$t('form.title.consultation')"
        @closeModal="$emit('closeModal')"
        @formSubmitted="$emit('formSubmitted')"
      />
    </div>
  </div>
</template>

<script>
import ConsultationForm from './ConsultationForm.vue';

export default {
  name: 'ConsultationModal',
  components: {
    ConsultationForm
  }
};
</script>
